import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';

@Injectable()
export class SignedUrlService {
  constructor(protected http: ApiClient) {}

  getSignedUrl(path: string) {
    return this.http.post<{ url: string }>(`generate-signed-url`, { path });
  }
}
